module.exports = __webpack_public_path__ + "img/ic-time-black.1d6ce987.svg";